import { ScriptInjectionService } from '@/services/ScriptInjectionService';
import { CHATBOT_TYPES } from '@/@core/constants/integrations';

/**
 * Composable for handling community chatbot injection
 */
export function useCommunityChatbot() {
  /**
   * Injects chatbot script based on community configuration
   * 
   * @param {Object} options - Chatbot configuration options
   * @param {number|null} options.showChatbot - Chatbot type (2: Crisp, 3: Hubspot, 4: chatbot.com, 5: landbot.io)
   * @param {string|null} options.customChatbot - Custom chatbot ID
   * @param {boolean} options.isBackoffice - Whether we're in backoffice
   */
  const injectChatbot = ({ showChatbot, customChatbot, isBackoffice = false }) => {
    try {
      // Nectios Support Chat only in Backoffice (currently disabled)
      if (isBackoffice) {
        // chatBot.innerText = 'window.$crisp=[];window.CRISP_WEBSITE_ID="a1aa36a2-c0e5-44a4-bc75-c5f95f1af801";(function(){d=document;s=d.createElement("script");s.src="https://client.crisp.chat/l.js";s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();';
        // Crisp.user.setEmail(this.$store.getters.loggedUser.email);
        return;
      }

      // Validate chatbot configuration
      if (!showChatbot || !customChatbot) {
        return;
      }

      // Ensure customChatbot doesn't contain 'window.' (invalid configuration)
      if (customChatbot.includes('window.')) {
        console.warn('Invalid chatbot configuration: customChatbot contains "window."');
        return;
      }

      // Use ScriptInjectionService for consistent injection
      ScriptInjectionService.injectChatbot({
        type: showChatbot,
        customId: customChatbot,
      });
    } catch (error) {
      console.error('Error injecting chatbot:', error);
      // Don't throw - chatbot failures shouldn't break the app
    }
  };

  return {
    injectChatbot,
  };
}
